import { Numeric9CircleOutlineIcon } from './Numeric9CircleOutlineIcon';

/**
 * author: Contributors
 * id F27ABCBB-C6D6-4C1E-AF0C-C406057245AA
 * name numeric-9-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number9CircleOutlineIcon = Numeric9CircleOutlineIcon;
export default Number9CircleOutlineIcon